import { render, staticRenderFns } from "./widgetSslVpnTunnel.vue?vue&type=template&id=5df19de5&scoped=true&"
import script from "./widgetSslVpnTunnel.vue?vue&type=script&lang=js&"
export * from "./widgetSslVpnTunnel.vue?vue&type=script&lang=js&"
import style0 from "./widgetSslVpnTunnel.vue?vue&type=style&index=0&id=5df19de5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df19de5",
  null
  
)

export default component.exports